import * as z from "zod/v4";

export const disconnectGoogleMerchantCenter = {
  name: "disconnectGoogleMerchantCenter" as const,
  input: z.null(),
  output: z.object({ success: z.boolean() }),
};
